import React from "react";

const Space = () => {
  return (
    <div
      class="flex flex-col items-center justify-start self-stretch shrink-0 relative"
      style={{ transformOrigin: "0 0", transform: "rotate(0deg) scale(1, 1)" }}
    >
      <div
        class="bg-[#006400] sm:pt-2 md:pt-3 lg:pt-4 xl:pt-5 flex flex-row items-center justify-between self-stretch shrink-0 relative pt-2"
        style={{
          transformOrigin: "0 0",
          transform: "rotate(0deg) scale(1, 1)",
        }}
      >
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transformOrigin: "0 0",
            transform: "rotate(-0.598deg) scale(1, 1)",
          }}
        >
          Frontend
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transformOrigin: "0 0",
            transform: "rotate(-0.598deg) scale(1, 1)",
          }}
        >
          -
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transformOrigin: "0 0",
            transform: "rotate(-0.598deg) scale(1, 1)",
          }}
        >
          Backend
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transformOrigin: "0 0",
            transform: "rotate(-0.598deg) scale(1, 1)",
          }}
        >
          -
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transformOrigin: "0 0",
            transform: "rotate(-0.598deg) scale(1, 1)",
          }}
        >
          design
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transformOrigin: "0 0",
            transform: "rotate(-0.598deg) scale(1, 1)",
          }}
        >
          -
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transformOrigin: "0 0",
            transform: "rotate(-0.598deg) scale(1, 1)",
          }}
        >
          Frontend
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transformOrigin: "0 0",
            transform: "rotate(-0.598deg) scale(1, 1)",
          }}
        >
          -
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transformOrigin: "0 0",
            transform: "rotate(-0.598deg) scale(1, 1)",
          }}
        >
          Backend
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transformOrigin: "0 0",
            transform: "rotate(-0.598deg) scale(1, 1)",
          }}
        >
          -
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transformOrigin: "0 0",
            transform: "rotate(-0.598deg) scale(1, 1)",
          }}
        >
          design
        </div>
      </div>
      <div
        class="bg-[#006400] sm:pb-0.5 md:pb-2 lg:pb-4 xl:pb-5 flex flex-row justify-between self-stretch opacity-70 shrink-0 relative pt-1"
        style={{
          transform: "rotate(0deg) scale(-1, 1)",
        }}
      >
        <div
          class="text-[#919191] text-center font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transform: "rotate(0deg) scale(-1, 1)",
            filter: "blur(2px)",
          }}
        >
          design
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transform: "rotate(0deg) scale(-1, 1)",
            filter: "blur(2px)",
          }}
        >
          -
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transform: "rotate(0deg) scale(-1, 1)",
            filter: "blur(2px)",
          }}
        >
          Backend
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transform: "rotate(0deg) scale(-1, 1)",
            filter: "blur(2px)",
          }}
        >
          -
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transform: "rotate(0deg) scale(-1, 1)",
            filter: "blur(2px)",
          }}
        >
          Frontend
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transform: "rotate(0deg) scale(-1, 1)",
            filter: "blur(2px)",
          }}
        >
          -
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transform: "rotate(0deg) scale(-1, 1)",
            filter: "blur(2px)",
          }}
        >
          design
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transform: "rotate(0deg) scale(-1, 1)",
            filter: "blur(2px)",
          }}
        >
          -
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transform: "rotate(0deg) scale(-1, 1)",
            filter: "blur(2px)",
          }}
        >
          Backend
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transform: "rotate(0deg) scale(-1, 1)",
            filter: "blur(2px)",
          }}
        >
          -
        </div>
        <div
          class="text-[#919191] text-left font-['JejuGothic-Regular',_sans-serif] sm:text-xl md:text-xl lg:text-2xl xl:text-3xl font-normal uppercase relative select-none"
          style={{
            transform: "rotate(0deg) scale(-1, 1)",
            filter: "blur(2px)",
          }}
        >
          Frontend
        </div>
      </div>
    </div>
  );
};
export default Space;
